export default __webpack_public_path__ + "static/media/WaterPulseIcon.b37ed853.svg";